// @flow

import React, { type Node } from 'react';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getUpiIntentAppNamesInOpenedPayment } from '@tectonics/prs/incoming-payment/get-upi-intent';
import { FieldIndiaUpiApp } from '../../../../customer-form/india/field-india-upi-app';

export function EwalletUpiIntentFields(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const appLinks = getUpiIntentAppNamesInOpenedPayment(incomingPayment) ?? '';

  return (
    <FieldIndiaUpiApp
      upiAppLinks={appLinks}
    />
  );
}
